import { Div, StatusMark } from '../../../styles/styles';
import { lightTheme } from '../../../styles/theme';
import { ConversationMessageWithStatus } from '../../../types/conversation.types';
import { ReplyStrip, ReplyStripBody } from '../chatSurfaces.styled';
import { ASSISTANT_LABEL } from '../helpers/chatMessage';

/**
 * What sits above a message's own content: the message it quotes, and the order
 * it is pinned to.
 *
 * Called the lead because it reads as part of the text - which is why a media
 * message carrying either one is drawn in the captioned layout rather than as a
 * bare picture.
 */
export const MessageLead = ({
  message,
  own,
  onOpenOrder,
  onOpenReply,
}: {
  message: ConversationMessageWithStatus;
  own: boolean;
  onOpenOrder?: (orderId: number) => void;
  /** Jump to the quoted message. Absent for one that has been deleted. */
  onOpenReply?: (messageId: number) => void;
}) => {
  // Only a real, still-present message can be jumped to.
  const replyTarget =
    message.replyTo && !message.replyTo.deleted ? message.replyTo.id : null;

  return (
    <>
      {message.replyTo && (
        <ReplyStrip
          $inBubble
          $own={own}
          $clickable={!!replyTarget && !!onOpenReply}
          onClick={
            replyTarget && onOpenReply
              ? () => onOpenReply(replyTarget)
              : undefined
          }
        >
          {/* Red marks the quote on an incoming bubble; on your own, which IS
              that red, it would be an invisible stripe. */}
          <StatusMark
            $color={own ? lightTheme.white : lightTheme.primary}
            $width="4px"
            $height="40px"
          />
          <ReplyStripBody>
            <b>
              {/* The quote names the assistant too, or a reply to the bot
                  would read as a reply to a colleague. */}
              {message.replyTo.isAssistant
                ? ASSISTANT_LABEL
                : message.replyTo.senderName}
            </b>
            <span>
              {message.replyTo.deleted
                ? 'Message deleted'
                : message.replyTo.preview}
            </span>
          </ReplyStripBody>
        </ReplyStrip>
      )}

      {message.orderId && (
        <Div
          $mb="6"
          $pointer={!!onOpenOrder}
          onClick={() => message.orderId && onOpenOrder?.(message.orderId)}
        >
          <u>{message.orderLabel ?? `Order #${message.orderId}`}</u>
        </Div>
      )}
    </>
  );
};
